import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {change, reduxForm} from "redux-form";
import {getAgencyServerProjectArticlesInCartSplit, getConsumerArticlesInCartSplit, isProjectSelected} from "../../../selectors/ProjectSelection";
import HintWrapper from "../../../components/HintWrapper";
import {addItemToCart, queueItemOperation, removeItemFromCartByArticleNumber} from "../../../actions/Cart";
import {queryProjectRemove, queryProjectSelection} from "../../../actions/ProjectSelection";
import {querySelectCartProperty} from "../../../actions/Properties";
import {delve} from "../../../util/util";
import {getAccounts, getArticleOptionCollections, getArticleOptionsData, getCartItems, getCartProjectPassword, getContracts} from "../../../selectors/SimpleSelectors";
import LabeledSlider from "../../../components/forms/LabeledSlider";
import LabeledToggleSelection from "../../../components/forms/LabeledToggleSelection";
import ArticleConfiguratorFormField from "../../../components/configurator/ArticleConfiguratorFormField";
import clsx from "clsx";
import {
    APP_MODE_OUTSOURCING,
    APP_MODE_PRODUCT_CHANGE,
    ARTICLE_CONFIGURATOR_LAYOUT_AGENCY,
    ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE,
    ARTICLE_CONFIGURATOR_MODE_CMS,
    ARTICLE_CONFIGURATOR_MODE_SHARED,
    ARTICLE_CONFIGURATOR_MODE_SHOP,
    DOMAIN_TYPE_CUSTOM,
    DOMAIN_TYPE_DEV,
    PROJECT_STATE_DEV,
    PROJECT_STATE_LIVE
} from "../../../constants/General";
import {isMode} from "../../../selectors/Mode";
import ReactTooltip from "react-tooltip";
import {agencyServerArticleNumber, devProjectArticleNumber, getArticleConfiguratorData, getAvailableAccessoryArticles} from "../../../config/Config";
import PropTypes from "prop-types";
import LabeledInput from "../../../components/forms/LabeledInput";
import PasswordStrengthTooltip from "../../../components/forms/PasswordStrengthTooltip";
import {PASSWORD_VALIDATION_DIGIT, PASSWORD_VALIDATION_LENGTH, PASSWORD_VALIDATION_MATCHING, PASSWORD_VALIDATION_SPECIAL, PASSWORD_VALIDATION_UPPER_LOWER} from "../../../constants/PasswordStrength";
import SoftwareSelect from "../SoftwareSelect";
import {generateProjectPassword} from "../../../actions/Password";
import PasswordHint from "../PasswordHint";
import {validatePassword} from "../../../util/password";
import ArticleConfiguratorCostsDisplay from "../../../components/configurator/ArticleConfiguratorCostsDisplay";
import {selectDomainTypeIfNoDomainsInCart} from "../../../actions/Domain";
import {togglePasswordVisibility} from "../../../actions/UserInterface";
import {backupHint, projectNameHint, projectStateHint, securityHint, softwareHint, storageHint, typeHint, visitorHint} from "../../../components/configurator/ArticleConfiguratorTooltip";
import {selectBaseArticle} from "../../../actions/BaseArticle";
import Collapsible from "../../util/Collapsible";
import ArticleInlineSelection from "../ArticleInlineSelection";
import {getCustomDisplayData} from "../../../selectors/Hardware";
import {getArticleOptionsInCartList} from "../../../selectors/CartUtil";
import {getTotalCartCosts} from "../../../selectors/Cart";
import {getAccountBackupRange, getAccountExtraStorage, getAccountStorageUsage, getCurrentAccountByContract} from "../../../selectors/Accounts";
import {getSelectedArticleProjectSpace} from "../../../selectors/ArticleConfigurator";
import {getProjectSelectionForm} from "../../../selectors/Forms";
import AppPreloader from "../../../components/AppPreloader";
import {getContractByParamOrAccount} from "../../../selectors/Contract";

function mapStateToProps(state, ownProps) {

    const contracts = getContracts(state)
    const contractIdentifier = getContractByParamOrAccount(state);
    const contract = contracts ? contracts[contractIdentifier] : null;

    const articleConfiguratorData = getArticleConfiguratorData(state);
    const configuration = ownProps && articleConfiguratorData[ownProps.mode] ? articleConfiguratorData[ownProps.mode] : articleConfiguratorData['shared'];
    const form = getProjectSelectionForm(state);
    const accounts = getAccounts(state);
    const currentAccount = getCurrentAccountByContract(state);

    //todo: use selector for the procedure in this method
    const regex = /([\d.]{1,})/

    const currentValues = form && form.values;
    const selectedArticleProjectSpace = getSelectedArticleProjectSpace(state);

    const projectState = (currentValues && currentValues.state) || 'live';
    const projectStateLabel = currentValues ? delve(configuration, `projectStates.${currentValues.state}.label`) : '';

    let currentAccountVisitorIndex = null;
    let currentAccountArticle = null;
    let accountStorageUsage = null;
    let accountExtraStorage = null;
    let accountStorageUsagePercent = null;
    let storageExceedingSteps = null;
    let accountBackupIndex = null;

    let articlesNotBeingAdded = [];
    if (isMode(APP_MODE_PRODUCT_CHANGE) && currentAccount) {
        articlesNotBeingAdded = ["" + delve(currentAccount, "article.articleNumber")];
    }

    // varnish, elasticsearch
    const potentialAddonArticles = getAvailableAccessoryArticles(state);
    let validAddonArticles = [];

    // assign config
    const projectTypes = {...configuration.projectStates[projectState].projectTypes};
    let backupRangeOptions = [...configuration.backupRange];

    // build size options
    let visitorOptions = [];
    let storageOptions = [];
    let defaultVisitorOption = null;

    let projectStateOptions = Object.keys(configuration.projectStates).map((state) => {
        return configuration.projectStates[state];
    });

    let projectTypeOptions = Object.keys(projectTypes).map((type) => {
        return projectTypes[type];
    });


    if (currentValues && currentValues.type && projectTypes[currentValues.type]) {
        visitorOptions = projectTypes[currentValues.type].articles
        defaultVisitorOption = projectTypes[currentValues.type].default;
    } else {
        visitorOptions = projectTypes[Object.keys(projectTypes)[0]].articles;
        defaultVisitorOption = projectTypes[Object.keys(projectTypes)[0]].default;
    }

    if (state.articleData && state.articleData.articleOptions) {
        visitorOptions = visitorOptions.map(articleId => {
            let visitors = delve(state, "articleData.articleOptions." + articleId + ".limits.visitors");
            if (!visitors) {
                const title = delve(state, "articleData.articleOptions." + articleId + ".title");
                if (title) {
                    // if limits are not available, use title to get visitor count
                    visitors = regex.exec(title)[1].replace(".", "");
                } else {
                    return false;
                }
            }
            return {
                visitors: visitors,
                label: "" + (new Intl.NumberFormat('de-DE', {useGrouping: true}).format(parseInt(visitors))) + " Besucher / Monat",
                value: "" + articleId
            }
        }).filter(Boolean);

        // build storage article option only if article is not DEV-Projekt
        if (currentValues && currentValues.article) {
            if (
                currentValues.article !== devProjectArticleNumber
                && delve(state, `articleData.articleOptionCollection.${currentValues.article}.hardware.hddSw`)
            ) {
                storageOptions = state.articleData.articleOptionCollection[currentValues.article].hardware.hddSw.map(articleId => {
                    if (typeof articleId === "string" && articleId.substr(0, 7) === "default") {
                        // remove default options from storageOptions
                        return false;
                    }
                    const optionUsageGB = Number(regex.exec(state.articleData.articleOptions[articleId].title)[1]);
                    //const optionUsageGB = Number(state.articleData.articleOptions[articleId].storageSpaceKb) / 1024 / 1024;
                    return {
                        label: (selectedArticleProjectSpace > 0 ? (optionUsageGB + selectedArticleProjectSpace) : ("+" + optionUsageGB)) + " GB",
                        value: "" + articleId,
                        gb: optionUsageGB + selectedArticleProjectSpace,
                        raw: optionUsageGB
                    }
                }).filter(Boolean);
            } else {
                storageOptions = [];
            }
        }

        // inject default hdd option
        storageOptions = [
            {
                label: selectedArticleProjectSpace ? `${Number(selectedArticleProjectSpace).toFixed(0)} GB inkl.` : 'Standardgröße',
                value: "",
                gb: selectedArticleProjectSpace
            },
            ...storageOptions
        ]

        if (currentAccount && currentValues && currentValues.article) {

            currentAccountVisitorIndex = 0;

            const currentAccountArticleNumber = delve(accounts, currentAccount + ".article.articleNumber");
            const articleOptions = getArticleOptionsData(state);
            const currentAccountVisitorLimit = parseInt(delve(articleOptions, currentAccountArticleNumber + '.limits.visitors'));
            let previousAccountVisitorLimit = visitorOptions[0].visitors, isFirst = true;

            for (let i = 1; i < visitorOptions.length; i++) {
                const visitorOption = visitorOptions[i];
                if (currentAccountVisitorLimit > visitorOption.visitors) {
                    currentAccountVisitorIndex++;
                } else {
                    currentAccountVisitorIndex += ((currentAccountVisitorLimit - previousAccountVisitorLimit) / (visitorOption.visitors - previousAccountVisitorLimit));
                    break;
                }
                previousAccountVisitorLimit = visitorOption.visitors;
            }

            if (currentAccountVisitorIndex < 0) {
                currentAccountVisitorIndex = 0;
            }
        }


        if (currentAccount && currentValues && currentValues.article && delve(accounts, currentAccount + ".stats.limit") !== -1) {

            // article
            currentAccountArticle = delve(accounts, currentAccount + ".article.articleNumber");

            if (["696969", "72002"].indexOf(currentAccountArticle + "") === -1) {
                // only allow upgrade to dev article if existing article is SPIELWIESE or dev article
                projectStateOptions = projectStateOptions.filter((elem) => elem.value !== PROJECT_STATE_DEV);
            }

            if (isMode(APP_MODE_PRODUCT_CHANGE) && currentAccountArticle) {
                articlesNotBeingAdded = ["" + currentAccountArticle];
            }

            // storage
            accountExtraStorage = getAccountExtraStorage(state);
            accountStorageUsage = getAccountStorageUsage(state);

            const initialStorageLimit = selectedArticleProjectSpace + accountExtraStorage;

            if (accountExtraStorage > 0) {
                storageOptions = storageOptions.map((storageOption) => {
                    // update storage option labels
                    return {
                        ...storageOption,
                        ...{
                            gb: storageOption.gb + Number(accountExtraStorage),
                            label: Number(storageOption.gb + Number(accountExtraStorage)) + ' GB',
                            raw: storageOption.raw
                        },
                    };
                });
            } else {
                // remove inclusive Label if account data is available
                storageOptions[0].label = Number(storageOptions[0].gb) + ' GB'
            }

            let selectedStorageLimit = selectedArticleProjectSpace + accountExtraStorage;

            if (currentValues && currentValues.storage) {
                const selectedStorageIndex = storageOptions.findIndex((storageOption) => storageOption.value === currentValues.storage);
                selectedStorageLimit = selectedStorageIndex >= 0 ? storageOptions[selectedStorageIndex].gb : 0;
            }

            // remove options that will lead to too much storage
            storageOptions = storageOptions.filter((storageOption) => {
                return storageOption.raw === undefined || storageOption.raw + accountExtraStorage <= 500;
            })


            accountStorageUsagePercent = Math.min(100, accountStorageUsage / selectedStorageLimit * 100);

            if (accountStorageUsage > initialStorageLimit) {

                // calculate exceeding storage in storage option steps
                let remainingExceedingStorage = (accountStorageUsage - initialStorageLimit);
                storageExceedingSteps = 0;

                let previousStorageOptionGB = storageOptions[0].gb;

                storageOptions.forEach((storageOption, idx) => {
                    if (idx > 0) {
                        if (remainingExceedingStorage > (storageOption.gb - previousStorageOptionGB)) {
                            remainingExceedingStorage -= (storageOption.gb - previousStorageOptionGB);
                            storageExceedingSteps += 1;
                        } else if (remainingExceedingStorage > 0) {
                            storageExceedingSteps += remainingExceedingStorage / (storageOption.gb - previousStorageOptionGB);
                            remainingExceedingStorage = 0;
                        }
                        previousStorageOptionGB = storageOption.gb;
                    }
                });
                storageExceedingSteps *= 1 / (storageOptions.length - 1);
            }


            if (!currentValues.storage && !ownProps.hideStorage && storageOptions && storageOptions.length > 0) {
                currentValues.storage = storageOptions[0].value
            }
        }

        if (currentAccount) {
            accountBackupIndex = backupRangeOptions.findIndex((backupOption) => backupOption.value === getAccountBackupRange(state));
        }
    }

    const passwordInCart = getCartProjectPassword(state);
    let showPasswordState = false;

    if (passwordInCart && currentValues && !currentValues.projectPassword) {
        showPasswordState = true;
    }

    // build calculated price
    let costs = 0;

    if (ownProps.connectToCart) {

        costs = getTotalCartCosts(state).priceMonthly;

        const itemsInCart = getCartItems(state);

        if (delve(itemsInCart, '0.identifier') === agencyServerArticleNumber) {
            // if agency server, subtract the agency server base price from displayed costs
            costs -= delve(state.articleData.articleOptions, agencyServerArticleNumber + ".price.default.net") || 0;
        }

        if (
            isMode(APP_MODE_PRODUCT_CHANGE)
            || isMode(APP_MODE_OUTSOURCING)
        ) {

            const accounts = getAccounts(state)
            const currentAccountArticle = delve(accounts, currentAccount + ".article.articleNumber");

            const agencyProjectArticlesInCart = getAgencyServerProjectArticlesInCartSplit(state);
            const consumerProjectsInCart = getConsumerArticlesInCartSplit(state);

            if (agencyProjectArticlesInCart.article.length > 0 || consumerProjectsInCart.article.length > 0) {
                if (contract) {
                    costs -= Number(delve(contract, 'contractPrice'));
                } else {
                    costs -= delve(state.articleData.articleOptions, currentAccountArticle + ".price.default.net") || 0;
                }
            }
        }

    } else {
        // if not connected to cart, price is only calculated by base article and selected storage
        if (currentValues && currentValues.article) {
            costs += delve(state.articleData.articleOptions, currentValues.article + ".price.default.net") || 0;
        }
        if (currentValues && currentValues.storage) {
            costs += delve(state.articleData.articleOptions, currentValues.storage + ".price.default.net") || 0;
        }
    }

    if (currentValues && currentValues.article) {
        const articleOptionCollectionsData = getArticleOptionCollections(state);

        // check for potential paidsoftware
        potentialAddonArticles.forEach((potentialAddonArticle) => {
            let isValidAddonArticle = false;
            if (articleOptionCollectionsData[currentValues.article] && articleOptionCollectionsData[currentValues.article].paidSoftware) {
                Object.keys(articleOptionCollectionsData[currentValues.article].paidSoftware).forEach((typeKey) => {
                    // loop all keys like paidSoftware
                    if (articleOptionCollectionsData[currentValues.article].paidSoftware[typeKey].includes(potentialAddonArticle)) {
                        isValidAddonArticle = true;
                    }
                })
            }
            if (isValidAddonArticle) {
                validAddonArticles.push(potentialAddonArticle);
            }
        });
    }


    return {
        currentAccountVisitorIndex,
        windowWidth: window.innerWidth,
        form: "projectSelection",
        showPasswordState,
        projectStateOptions,
        isProjectSelected: isProjectSelected(state),
        articleData: state.articleData,
        showPassword: delve(state, "ui.showPassword"),
        selectedType: currentValues,
        cartIsFetching: state.cart && state.cart.isFetching,
        potentialAddonArticles,
        validAddonArticles,
        validAddonArticlesDisplay: getCustomDisplayData(state, validAddonArticles),
        articleOptionsInCart: getArticleOptionsInCartList(state),
        visitorOptions,
        isQueryingAddInitial: state.cart && state.cart.isQueryingAddInitial,
        projectTypes,
        storageOptions,
        articlesNotBeingAdded,
        projectTypeOptions,
        backupRangeOptions,
        accountBackupIndex,
        defaultVisitorOption,
        costs,
        projectState,
        projectStateLabel,
        currentAccountArticle,
        accountStorageUsage,
        storageExceedingSteps,
        accountExtraStorage,
        accountStorageUsagePercent,
        selectedArticleProjectSpace
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        handleProjectSelectionSubmit: (values, dispatch, props) => {
            if (props.isProjectSelected) {
                return dispatch(queryProjectRemove(values))
            } else {
                return dispatch(queryProjectSelection(values))
            }
        },
        togglePasswordVisibility: () => {
            return dispatch(togglePasswordVisibility());
        },
        generatePassword: (e) => {
            e.preventDefault();
            return dispatch(generateProjectPassword("projectSelection"));
        }
    };
}

class ArticleConfigurator extends React.Component {

    constructor(props) {
        super(props);

        this.tooltipMaxRef = React.createRef();
    }

    /**
     * backup: show backup in personalization by default. is personalization is hidden, show in upper group instead only if hideBackup is false and if only one projectstate option
     */
    render() {

        const props = this.props;

        const maxValueHint = <React.Fragment>
            <p>
                <strong>Da geht noch mehr!</strong>
            </p>
            <p>
                Du erwartest mehr als {props.visitorOptions[props.visitorOptions.length - 1].label} oder extreme Traffic-Spitzen? Kein Problem. Selbst wenn du besondere Features brauchst, frag uns einfach. Wir erstellen dir dein Hosting nach Maß!
            </p>
            <a
                target={"_blank"}
                rel={"no-referer"}
                href={"https://www.mittwald.de/individual-hosting"}
            >
                Zum Individualhosting >
            </a>
        </React.Fragment>;

        let headline;

        const renderBackupStandalone = !props.hideBackup && props.hidePersonalization && props.projectStateOptions.length > 1;
        const renderBackupInTopGroup = !props.hideBackup && props.hidePersonalization && props.projectStateOptions.length <= 1;

        if (props.mode === ARTICLE_CONFIGURATOR_MODE_SHARED) {
            if (props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
                headline = 'Dein 1. Projekt';
            } else if (props.hidePersonalization) {
                headline = 'Wähle deinen Projekt-Tarif';
            } else {
                headline = 'Schritt 1: Definiere dein Projekt';
            }
        } else {
            if (props.isStandaloneProduct) {
                if (props.hidePersonalization) {
                    headline = 'Definiere dein Projekt';
                } else {
                    headline = 'Schritt 1: Zusätzlichen Speicherplatz hinzufügen';
                }
            } else {
                headline = 'Tarif-Konfigurator';
            }
        }

        return <form
            onSubmit={props.handleSubmit(props.handleProjectSelectionSubmit)}
            className={clsx("article-configurator", props.hidePersonalization && !renderBackupStandalone && " article-configurator--single", props.layout && ("article-configurator--layout-" + props.layout))}
        >
            {props.isQueryingAddInitial ? <div className={"article-configurator__loader"}><AppPreloader label=""/></div> : null}
            <div className={"article-configurator__box article-configurator__box--configuration"}>
                <div
                    className={"article-configurator__form"}
                >
                    {props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ?
                        <Fragment>
                            <h3>Agentur-Server</h3>
                            <p>Die Homebase für alle deine Projekte von 1 bis unendlich. Ein zentraler Login sowie zeitsparende Features sorgen für volle Kontrolle und Überblick über alle Projekte. Jedes Projekt profitiert von der flexibel erweiterbaren Tarifstruktur - bei stets optimaler
                                Performance.</p>
                        </Fragment> : null}
                    <h4>{headline}</h4>
                    {this.state && this.state.showStorageReduceHint ? <HintWrapper
                        theme="blue"
                        content={"Um Speicherplatz zu reduzieren, wende dich bitte an unseren Kundenservice."}
                    /> : null}
                    <div className={"article-configurator__body"}>
                        {props.projectStateOptions && props.projectStateOptions.length > 1 ? <React.Fragment>
                            {props.layout === ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? <div className={"article-configurator__new-wrapper"}>
                                <div className={"article-configurator__new-dev"}>
                                    NEU: Kostenlos entwickeln!
                                </div>
                            </div> : null}
                            {(props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY && props.projectState === "dev") ?
                                <div className={"article-configurator__agency-hint"}>
                                    <div> Ohne Umwege loslegen. Mit dem <strong>DEV-Projekt</strong> kannst du in aller Ruhe kostenlos entwickeln und testen. Sobald alles steht, kannst du es mit wenigen Klicks in ein Live-Projekt überführen.</div>
                                    <a
                                        onClick={(e) => {
                                            props.change('state', 'live');
                                        }}
                                    >Du hast bereits ein <strong>LIVE-Projekt</strong>?</a>
                                </div> : null}
                            {(props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY && props.projectState === "live") ?
                                <div className={"article-configurator__agency-hint"}>
                                    <div>Dein Projekt soll direkt online gehen oder du ziehst ein bestehendes Projekt zu Mittwald um? Dann ist ein <strong>LIVE-Projekt</strong> die richtige Wahl.</div>
                                </div> : null}
                            {(props.layout !== ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live") ? <ArticleConfiguratorFormField
                                label="Projekt-Status"
                                tooltip={projectStateHint}
                                tooltipId={'projectState'}
                                windowWidth={props.windowWidth}
                            >
                                <LabeledToggleSelection
                                    options={props.projectStateOptions}
                                    layout={props.layout}
                                    fieldId={'state'}
                                    disabled={props.cartIsFetching}
                                />
                            </ArticleConfiguratorFormField> : null}
                            {props.layout !== ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ? <ArticleConfiguratorFormField
                                label={props.projectStateLabel}
                                tooltip={""}
                                tooltipId={'projectStateExplanation'}
                                windowWidth={props.windowWidth}
                            >
                                {props.projectState === PROJECT_STATE_LIVE ? <div className={"article-configurator__description"}>
                                    Dein Projekt soll direkt an den Start gehen oder du ziehst ein bestehendes Projekt zu Mittwald um? Dann ist ein LIVE-Projekt die richtige Wahl. Projekt-Typ, Besucherzahl und Speicherplatz festlegen – fertig.
                                </div> : <div className={"article-configurator__description"}>
                                    Entwickle und teste mit dem kostenlosen DEV-Projekt und lass deinen kreativen Ideen freien Lauf! Überführe dein DEV-Projekt in ein LIVE-Projekt, sobald deine Entwicklung abgeschlossen ist. <a
                                    target={"_blank"}
                                    href={"https://www.mittwald.de/faq/neue-tarife/dev-projekte"}
                                >Mehr
                                    erfahren</a>
                                </div>}
                            </ArticleConfiguratorFormField> : null}
                        </React.Fragment> : null}
                        {props.projectTypeOptions && props.projectTypeOptions.length > 1 ? <ArticleConfiguratorFormField
                            label="Projekt-Typ"
                            tooltip={typeHint}
                            tooltipId={'type'}
                            windowWidth={props.windowWidth}
                        >
                            <LabeledToggleSelection
                                options={props.projectTypeOptions}
                                layout={props.layout}
                                fieldId={'type'}
                                disabled={props.cartIsFetching}
                            />
                        </ArticleConfiguratorFormField> : null}
                        {(props.layout !== ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live") ? <ArticleConfiguratorFormField
                            label={"Volle Performance für bis zu"}
                            tooltip={visitorHint}
                            tooltipId={"article"}
                            windowWidth={props.windowWidth}
                        >
                            <LabeledSlider
                                options={props.visitorOptions}
                                markerAtIndex={props.currentAccountVisitorIndex}
                                fieldId={'article'}
                                layout={props.layout}
                                disabled={props.cartIsFetching}
                                onMaximumDeselected={(e) => {
                                    ReactTooltip.hide(this.tooltipMaxRef.current);
                                }}
                                onMaximumSelected={(e) => {
                                    ReactTooltip.show(this.tooltipMaxRef.current);
                                }}
                            />
                        </ArticleConfiguratorFormField> : null}
                        {props.visitorOptions && props.visitorOptions.length > 1 ? <ArticleConfiguratorFormField
                            label={false}
                            tooltip={maxValueHint}
                            tooltipId={"max"}
                            windowWidth={props.windowWidth}
                            showRef={this.tooltipMaxRef}
                            tooltipPlace={"top"}
                        /> : null}
                        {!props.hideStorage && (props.layout !== ARTICLE_CONFIGURATOR_LAYOUT_AGENCY || props.projectState === "live") ? <ArticleConfiguratorFormField
                            label={"Speicherplatz"}
                            tooltip={storageHint}
                            tooltipId={"storage"}
                            windowWidth={props.windowWidth}
                        >
                            <LabeledSlider
                                options={props.storageOptions}
                                inlineDisplay={!!props.accountStorageUsage}
                                inlineDisplayLabel={props.accountStorageUsage ? (Number(props.accountStorageUsage).toFixed(2) + " GB verbraucht von") : null}
                                inlineDisplayPercent={props.accountStorageUsagePercent}
                                exceedingSteps={props.storageExceedingSteps}
                                markerAtIndex={props.accountStorageUsage ? 0 : null}
                                onRepeatableNegativeDrag={!!props.accountStorageUsage ? () => {
                                    this.setState({showStorageReduceHint: true})
                                } : null}
                                onClearPositiveDrag={!!props.accountStorageUsage ? () => {
                                    this.setState({showStorageReduceHint: false})
                                } : null}
                                fieldId={'storage'}
                                layout={props.layout}
                                disabled={props.cartIsFetching}
                            />
                        </ArticleConfiguratorFormField> : null}

                        {!props.hideAddons && props.validAddonArticlesDisplay && props.validAddonArticlesDisplay.length > 0 ? <ArticleConfiguratorFormField
                            label={"Add-Ons"}
                        >
                            <Collapsible
                                id="addons"
                                label="Hosting Add-Ons hinzubuchen"
                            >
                                {props.validAddonArticlesDisplay.map((articleData) => (
                                    <ArticleInlineSelection
                                        key={articleData.display.title}
                                        articleOptions={[articleData]}
                                        itemsPerRow={1}
                                        inlineOptionStyle="extended"
                                        canClearOnDoubleSelect={true}
                                    />
                                ))}
                            </Collapsible>
                        </ArticleConfiguratorFormField> : null}
                        {renderBackupInTopGroup ? <ArticleConfiguratorFormField
                            label={"Backupzeitraum"}
                            tooltip={backupHint}
                            tooltipId={"backup"}
                            windowWidth={props.windowWidth}
                            tooltipPlace={props.windowWidth < 768 ? 'top' : 'right'}
                        >
                            <LabeledSlider
                                options={props.backupRangeOptions}
                                markerAtIndex={props.accountBackupIndex}
                                fieldId={'backup'}
                                layout={props.layout}
                                disabled={props.cartIsFetching}
                            />
                        </ArticleConfiguratorFormField> : null}
                        {[ARTICLE_CONFIGURATOR_MODE_SHOP, ARTICLE_CONFIGURATOR_MODE_CMS].includes(props.mode) ?
                            <ArticleConfiguratorFormField
                                label={"Immer inklusive"}
                            >
                                <div className={"article-configurator__form-field__text"}>
                                    <span>1 Domain & Let´s Encrypt, alle CMS Tools</span>
                                    {props.hideStorage && props.selectedArticleProjectSpace ? <span>,<br/>{props.selectedArticleProjectSpace} GB Speicherplatz (erweiterbar)</span> : null}
                                </div>
                            </ArticleConfiguratorFormField>
                            : null}
                    </div>
                </div>
                <ArticleConfiguratorCostsDisplay
                    mode={props.mode}
                    costs={props.costs}
                    layout={props.layout}
                    state={props.projectState}
                />
            </div>
            {!props.hidePersonalization ? <div className={"article-configurator__box article-configurator__box--detail"}>
                <h4>Schritt 2: Personalisiere dein Projekt</h4>
                <ArticleConfiguratorFormField
                    label={"Allgemein"}
                    tooltip={projectNameHint}
                    tooltipId={"projectName"}
                    windowWidth={props.windowWidth}
                >
                    <LabeledInput
                        label={"Projekt-Name"}
                        fieldId={'projectName'}
                        forceValidation={props.forceValidation}
                    />
                </ArticleConfiguratorFormField>
                {props.showPasswordState ? <HintWrapper
                    content={"Die Seite wurde neu geladen und dein gewähltes Passwort wird dir nicht mehr angezeigt? Aus Sicherheitsgründen vergib bitte einfach an dieser Stelle ein neues Passwort."}
                    theme={"blue"}
                /> : null}
                <ArticleConfiguratorFormField
                    label={"Sicherheit"}
                    tooltip={securityHint}
                    tooltipId={"projectPassword"}
                    windowWidth={props.windowWidth}
                >
                    <div className="labeled-group">
                        <PasswordStrengthTooltip formIdentifier={props.form}/>
                        <LabeledInput
                            autocomplete={"new-password"}
                            type={props.showPassword ? 'text' : 'password'}
                            label={"Projekt-Passwort"}
                            fieldId={'projectPassword'}
                            togglePasswordCallback={props.togglePasswordVisibility}
                            showPassword={props.showPassword}
                            forceValidation={props.forceValidation}
                        />
                        <LabeledInput
                            autocomplete={"new-password"}
                            type={props.showPassword ? 'text' : 'password'}
                            label={"Projekt-Passwort wiederholen"}
                            fieldId={'projectPasswordRepeat'}
                            togglePasswordCallback={props.togglePasswordVisibility}
                            showPassword={props.showPassword}
                            forceValidation={props.forceValidation}
                        />
                        <div className={"article-configurator__password-generation"}>
                            ... oder <a href={'#'} onClick={props.generatePassword}>Passwort generieren</a>?
                        </div>
                    </div>
                </ArticleConfiguratorFormField>
                <PasswordHint formIdentifier={props.form}/>
                {!props.hideSoftware ? <ArticleConfiguratorFormField
                    label={"Software"}
                    tooltip={softwareHint}
                    tooltipId={"software"}
                    windowWidth={props.windowWidth}
                >
                    <SoftwareSelect/>
                </ArticleConfiguratorFormField> : null}
                {!props.hideBackup ? <ArticleConfiguratorFormField
                    label={"Backupzeitraum"}
                    tooltip={backupHint}
                    tooltipId={"backup"}
                    windowWidth={props.windowWidth}
                    tooltipPlace={props.windowWidth < 768 ? 'top' : 'right'}
                >
                    <LabeledSlider
                        options={props.backupRangeOptions}
                        markerAtIndex={props.accountBackupIndex}
                        fieldId={'backup'}
                        disabled={props.cartIsFetching}
                    />
                </ArticleConfiguratorFormField> : null}
            </div> : null}
            {renderBackupStandalone ? <div className={"article-configurator__box article-configurator__box--detail"}>
                <h4>Schritt 2: Wähle deinen gewünschten Backupzeitraum</h4>
                <ArticleConfiguratorFormField
                    label={"Backupzeitraum"}
                    tooltip={backupHint}
                    tooltipId={"backup"}
                    windowWidth={props.windowWidth}
                    tooltipPlace={props.windowWidth < 768 ? 'top' : 'right'}
                >
                    <LabeledSlider
                        options={props.backupRangeOptions}
                        fieldId={'backup'}
                        markerAtIndex={props.accountBackupIndex}
                        disabled={props.cartIsFetching}
                    />
                </ArticleConfiguratorFormField>
            </div> : null}
            {!props.hidePersonalization && !props.currentProduct && !props.isStandaloneProduct ? <HintWrapper
                alignment={"center"}
                theme={"blue"}
                content={"Weitere Projekte können später im Kundencenter flexibel dazugebucht werden."}
            /> : null}
        </form>;
    }
}


//TODO: rename form to configurator
ArticleConfigurator = reduxForm({// eslint-disable-line
    destroyOnUnmount: false,
    enableReinitialize: false,
    keepDirtyOnReinitialize: true,
    validate: (values, props) => {
        let errors = {};

        if (!props.hidePersonalization) {
            if (!values.projectName) {
                errors["projectName"] = "Bitte wähle einen Namen für dein Projekt."
            }
            if (!values.projectPasswordInCart || values.projectPassword) {
                // only validate password if it's not set in cart or if new password is entered
                if (!values.projectPassword) {
                    errors["projectPassword"] = "Bitte wähle ein Passwort für dein Projekt.";
                    errors["projectPasswordRepeat"] = " ";
                    errors["projectPasswordErrors"] = {
                        [PASSWORD_VALIDATION_LENGTH]: true,
                        [PASSWORD_VALIDATION_MATCHING]: true,
                        [PASSWORD_VALIDATION_UPPER_LOWER]: true,
                        [PASSWORD_VALIDATION_DIGIT]: true,
                        [PASSWORD_VALIDATION_SPECIAL]: true
                    };
                } else {
                    let passwordErrors = validatePassword(values.projectPassword, values.projectPasswordRepeat);
                    const amountErrors = Object.keys(passwordErrors).length

                    if (amountErrors > 0) {
                        errors["projectPasswordErrors"] = passwordErrors;
                        if (passwordErrors[PASSWORD_VALIDATION_MATCHING] && amountErrors === 1) {
                            errors["projectPassword"] = "";
                            errors["projectPasswordRepeat"] = "Bitte überprüfe deine Eingabe.";
                        } else {
                            errors["projectPassword"] = "Bitte überprüfe deine Eingabe.";
                        }
                    }
                }
            }
        }
        return errors;
    },
    onChange: (values, dispatch, props, previousValues) => {
        let article = values.article;
        if (previousValues && values.state !== previousValues.state) {
            // handle state change and set form fields if needed
            if (props.projectTypeOptions.length > 0) {
                dispatch(change(props.form, "type", props.projectTypeOptions[0].value));
            }
            if (values.state === 'live') {
                dispatch(selectDomainTypeIfNoDomainsInCart(DOMAIN_TYPE_CUSTOM));
            } else if (values.state === 'dev') {
                dispatch(selectDomainTypeIfNoDomainsInCart(DOMAIN_TYPE_DEV));
            }
            if (props.visitorOptions && props.visitorOptions.findIndex((elem) => elem.value === article) === -1) {
                dispatch(change(props.form, "article", props.defaultVisitorOption));
            }
            if (props.visitorOptions && props.visitorOptions[0] && props.visitorOptions[0].value === devProjectArticleNumber) {
                dispatch(change(props.form, "storage", ''));
            }
        }

        if (previousValues && values.type !== previousValues.type && previousValues.article === values.article) {

            // handle type change and set form fields if needed ( new article will be first in list )
            const previousArticleVisitorLimit = parseInt(delve(props.articleData.articleOptions, previousValues.article + '.limits.visitors'));

            if (props.visitorOptions.length > 0) {

                if (!props.forceDefaultOnTypeSwitch) {

                    // find first option that fulfills storage
                    let articleToSwitchToIndex = props.visitorOptions.findIndex((visitorOption) => {
                        return parseInt(visitorOption.visitors) >= previousArticleVisitorLimit;
                    });

                    let articleToSwitchTo = props.visitorOptions[articleToSwitchToIndex];

                    // check if previous option is closer
                    if (articleToSwitchToIndex >= 1 && !props.forceDefaultOnTypeSwitch) {
                        const potentiallyCloserArticle = props.visitorOptions[articleToSwitchToIndex - 1];
                        const switchToArticle = props.visitorOptions[articleToSwitchToIndex];

                        const differencePotentially = Math.abs(parseInt(potentiallyCloserArticle.visitors) - previousArticleVisitorLimit);
                        const differenceSwitchTo = Math.abs(parseInt(switchToArticle.visitors) - previousArticleVisitorLimit);

                        if (differencePotentially <= differenceSwitchTo) {
                            articleToSwitchTo = potentiallyCloserArticle;
                        }
                    }

                    if (articleToSwitchTo) {
                        articleToSwitchTo = articleToSwitchTo.value;
                    } else {
                        articleToSwitchTo = props.visitorOptions[Math.min(1, props.visitorOptions.length - 1)].value; // default
                    }

                    dispatch(change(props.form, "article", articleToSwitchTo))
                    article = articleToSwitchTo;

                } else {
                    dispatch(change(props.form, "article", props.defaultVisitorOption))
                    article = props.defaultVisitorOption;
                }
            }
        }

        let currentStorageOptionAvailable = false;

        // disable hardcoded devproject
        if (article !== devProjectArticleNumber && delve(props.articleData, `articleOptionCollection.${article}.hardware.hddSw`)) {
            props.articleData.articleOptionCollection[article].hardware.hddSw.forEach(articleId => {
                if (values && (values.storage === "" || values.storage === "" + articleId)) {
                    currentStorageOptionAvailable = true;
                }
            });
        }

        let storageReplacementOption = false;

        if (!currentStorageOptionAvailable) {

            if (values.storage) {
                // get matching storage replacement option
                props.articleData.articleOptionCollection[article].hardware.hddSw.forEach(articleId => {
                    if (delve(props.articleData.articleOptions, articleId + '.storageSpaceKb') === delve(props.articleData.articleOptions, values.storage + '.storageSpaceKb')) {
                        storageReplacementOption = articleId;
                    }
                });
            }
            dispatch(change(props.form, "storage", storageReplacementOption || ""));
        }

        if (props.onChangeInject) {
            props.onChangeInject(values);
        }

        if (props.connectToCart) {

            // compare values and swap articles for changed values, except for type and backup form values
            Object.keys(values).forEach(key => {
                if (previousValues[key] !== values[key]) {
                    if (key === "article" && props.updateSelectedArticle) {
                        // update selected base article if activated
                        dispatch(selectBaseArticle(values[key]));
                    }

                    // remove / add article in cart when changed field value belongs to article or storage input
                    if (key === "article" || key === "storage") {

                        const isAllowedArticle = values[key] && props.articlesNotBeingAdded.indexOf(values[key]) === -1;

                        // if previous value existed, remove it first and add afterwards
                        if (previousValues[key]) {
                            dispatch(queueItemOperation(removeItemFromCartByArticleNumber, previousValues[key], isAllowedArticle));
                        }
                        if (isAllowedArticle) {
                            dispatch(queueItemOperation(addItemToCart, values[key]));
                        }
                        if (key === "article") {
                            // check if addons are available
                            props.potentialAddonArticles.forEach((potentialAddonArticle) => {
                                if (
                                    props.articleOptionsInCart.includes('' + potentialAddonArticle) &&
                                    !props.validAddonArticles.includes(potentialAddonArticle)
                                ) {
                                    dispatch(queueItemOperation(removeItemFromCartByArticleNumber, potentialAddonArticle));
                                }
                            });
                        }
                    } else if (key === "backup") {
                        // backup field belongs to property on cart object
                        dispatch(querySelectCartProperty("backupRange", values[key]));
                    } else if (key === "projectName") {
                        // projectName field belongs to property on cart object
                        dispatch(querySelectCartProperty("projectName", values[key]));
                    } else if (key === "projectPassword" || key === "projectPasswordRepeat") {
                        // projectName field belongs to property on cart object
                        if (Object.keys(validatePassword(values.projectPassword, values.projectPasswordRepeat)).length === 0) {
                            dispatch(querySelectCartProperty("projectPassword", values[key]));
                            dispatch(querySelectCartProperty("projectPasswordInCart", false));
                        } else {
                            dispatch(querySelectCartProperty("projectPassword", ""));
                        }
                    }
                }
            })
        }

    }
})(ArticleConfigurator)// eslint-disable-line

ArticleConfigurator = connect(mapStateToProps, mapDispatchToProps)(ArticleConfigurator);// eslint-disable-line

ArticleConfigurator.propTypes = {
    hidePersonalization: PropTypes.bool,
    connectToCart: PropTypes.bool,
    hideBackup: PropTypes.bool,
    hideSoftware: PropTypes.bool,
    hideStorage: PropTypes.bool,
    hideAddons: PropTypes.bool,
    isStandaloneProduct: PropTypes.bool,
    updateSelectedArticle: PropTypes.bool,
    forceDefaultOnTypeSwitch: PropTypes.bool
};

ArticleConfigurator.defaultProps = {
    connectToCart: true,
    updateSelectedArticle: false
};

export default ArticleConfigurator



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/configurator/ArticleConfigurator.js
 **/